import { Injectable } from '@angular/core';
import { ElementTextModel } from './element-text.model';
import { WebsocketService } from './websocket/websocket.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AbstractCrudService } from './abstract-crud.service';

@Injectable({
  providedIn: 'root'
})
export class ElementTextService extends AbstractCrudService<ElementTextModel> {

  /**
   * URL for current model, override url from superclass
   * @type {string}
   */
  protected url = environment.regoApiURL + 'objectdescription';

  constructor(http: HttpClient) {
    super(http);
  }
}
